function DeployWorkspaceController() {
  const ctrl = this;
}

angular
  .module('pis-tool.module')
  .controller('DeployWorkspaceController', DeployWorkspaceController);
